import {Component, EventEmitter, Input, Output} from '@angular/core'

@Component({
  selector: 'app-button-navigation',
  templateUrl: './button-navigation.component.html',
  styleUrls: ['./button-navigation.component.scss']
})
export class ButtonNavigationComponent {

  @Input()
  previousLabel = 'Wróć'

  @Input()
  nextLabel = 'Dalej'

  @Input()
  previousVisible = true

  @Input()
  nextVisible = true

  @Input()
  previousEnabled = true

  @Input()
  nextEnabled = true

  @Output()
  previousClick = new EventEmitter()

  @Output()
  nextClick = new EventEmitter()

  previousClicked(): void {
    this.previousClick.emit()
  }

  nextClicked(): void {
    this.nextClick.emit()
  }

}
